import { render, staticRenderFns } from "./DehorningFirstPage.vue?vue&type=template&id=6956a408&scoped=true&"
import script from "./DehorningFirstPage.vue?vue&type=script&lang=js&"
export * from "./DehorningFirstPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6956a408",
  null
  
)

export default component.exports